export default __webpack_public_path__ + "static/media/image_double_50.6312e6da.svg";